import { render } from "./ResponseSingleChart.vue?vue&type=template&id=9ff71dfa"
import script from "./ResponseSingleChart.vue?vue&type=script&lang=js"
export * from "./ResponseSingleChart.vue?vue&type=script&lang=js"

import "./ResponseSingleChart.vue?vue&type=style&index=0&id=9ff71dfa&lang=css"
script.render = render

export default script